<template>
	<div  style="width: 100%;  height: 100vh;min-height:100vh ;   display:flex; flex-direction: column; justify-content: space-between; " >
		<div style="width: 100%; ">
			<headView ref="headview" ></headView>
			
			<router-view  ref="pageVIEW"/>
		</div>


		<div style="width: 100%; ">
			<buttom ></buttom>
		
		</div>
	</div>
</template>


<script>
	// @ is an alias to /src
	import buttom from '../components/home/public/buttom.vue'
	import headView from '../components/home/public/headView.vue'
	import bowser from 'bowser'
	export default {
		name: 'HomeView',
		components: {
			buttom,
			headView
		},
		data() {
			return {
				productList: [], //产品列表
				collectList: [], //收藏商品
			};
		},
		watch: {},
		computed: {},
		methods: {
			

		},
		created() {
			console.log('----判断浏览器版本----')
			var parser = bowser.getParser(window.navigator.userAgent)
			var bVersion = parser.getBrowserVersion();
			var bName = parser.getBrowserName();
			console.log(bName)
			console.log(bVersion)
		},
		mounted() {}
	}
</script>
<style scoped>
/* // html,body{ min-height:100vh; background-color:yellowgreen; } */

</style>
